import React from "react";
import { Navigate, createBrowserRouter, RouterProvider } from "react-router-dom";
import Exchange from "../../pages/Exchange/Exchange.jsx";
import Login from "../../pages/Exchange/Login/Login.jsx";
import VerifyToken from "../../pages/Exchange/VerifyToken/VerifyToken";
import Dashboard from "../../pages/Dashboard/Dashboard.jsx";
import { AuthLayout } from "../../components/layouts/AuthLayout/AuthLayout.jsx";
import Portfolio from "../../pages/Portfolio/Portfolio.jsx";
import PortfolioLayout from "../../pages/Portfolio/PortfolioLayout.jsx";
import PortfolioSingleWallet from "../../pages/Portfolio/PortfolioSingleWallet.jsx";
import Settings from "../../pages/Exchange/Settings/Settings.jsx";
import { RouteErrorFallback } from "../../components/common/ErrorBoundary";

// Create once at module scope — recreating inside render remounts the whole app.
const router = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/auth/login" replace />,
    errorElement: <RouteErrorFallback />,
  },
  {
    path: "auth",
    children: [
      {
        path: "login",
        element: <Login />,
      },
    ],
  },
  {
    path: "verify-token",
    element: <VerifyToken />,
  },
  {
    path: "",
    element: <AuthLayout />,
    errorElement: <RouteErrorFallback />,
    children: [
      {
        path: "trade",
        element: <Exchange />,
      },
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "portfolio",
        element: <PortfolioLayout />,
        children: [
          {
            index: true,
            element: <Portfolio />,
          },
          {
            path: "wallet-table",
            element: <PortfolioSingleWallet />,
          },
        ],
      },
      {
        path: "setting",
        element: <Settings />,
      },
    ],
  },
]);

const PublicRoutes = () => <RouterProvider router={router} />;

export default PublicRoutes;
